module.exports = __webpack_public_path__ + "img/party-bags.1ebb1a50.png";